export default __webpack_public_path__ + "static/media/chevron-down.7d09e319.svg";